import { render, staticRenderFns } from "./blockquote.vue?vue&type=template&id=74bcd0b6"
import script from "./blockquote.vue?vue&type=script&lang=js"
export * from "./blockquote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports